export const registrarInterface = {
    type: '',
    id: '',
    idMunicipio: '',
    Municipio: '',
    CargoNombre: '',
    Cargo: null,
    Email: null,
    files: [
      {
        file: '',
      },
    ],
  };
  